import React from 'react';
import autobind from 'autobind-decorator';
import { Grid, Cell, Offset } from 'react-ittsu/layout';
import gql from 'fraql';

import BaseServiceModal from '../BaseServiceModal';
import Paragraph from '../Paragraph';
import SectionTitle from '../SectionTitle';
import { ProductCard } from '../../forms';
import { priceItem, applyPrice } from '../../../utils/pricing';
import { specsToItems, itemsToSpecs } from '~/pods/order/utils/services/specs-to-items';
import applyChanges from '~/pods/order/utils/services/specs-to-items/apply-changes';
import { getItemsByService, merge } from '~/pods/order/utils';
import { createTranslate, translate as t } from '~/utils/translation';

import serviceImages from '~/pods/order/images/services';


const tt = createTranslate('pods.order.services.exterior_restyling.order');
const tm = createTranslate('pods.order.components.service_modal');


class ExteriorRestyling extends React.Component {

  static fragments = {
    Item: gql`
      fragment _ on Item {
        id
        details {
          ... on ExteriorRestylingDetails {
            numberOfImages
          }
        }
      }
    `,
  }

  state = {
    specs: {
      numberOfImages: 0,
      standard: false,
    },
    price: undefined,
  };

  componentDidUpdate(prevProps) {
    const { specs } = this.state;
    const { service, estate } = this.props;
    const { service: prevService } = prevProps;
    if (service?.id === 'exteriorRestyling' && ! prevService) {
      const newSpecs = itemsToSpecs({ estate, service });
      const items = getItemsByService(estate).exteriorRestyling;
      const price = items != null ? items.reduce((memo, i) => memo + priceItem(i, this.props.sessionUser.currency.code, true), 0) : 0;
      this.setState({ specs: merge(specs, newSpecs), price });
    }
  }

  render() {
    const { onClickClose, isVisible, service, estate, sessionUser } = this.props;
    const { specs: { numberOfImages }, price } = this.state;
    const { exteriorRestyling } = serviceImages;
    const items = getItemsByService(estate).exteriorRestyling;
    return (
      <BaseServiceModal
        isVisible={isVisible && service?.id === 'exteriorRestyling'}
        title={service?.id ? t(`services.${service.id}`) : ''}
        images={Object.values(exteriorRestyling)}
        price={sessionUser.addCurrency(price)}
        onClickConfirm={this._handleClickConfirm}
        confirmAsUpdate={items?.length > 0}
        onClickClose={onClickClose}
        addDisabled={price === 0}>
        <div className="childcontent">
          <Paragraph>
            {tt('description')}
          </Paragraph>
          <SectionTitle>
            {tt('choose_options')}
          </SectionTitle>
          <Grid withVGutters withHGutters>
            <Offset size="1of4" />
            <Cell size="2of4">
              <ProductCard
                name="standard"
                label={tm('standard')}
                note={`${applyPrice({ EUR: 100, GBP: 90, USD: 120 }, sessionUser)}/img`}
                fullHeight
                formComponent="radio"
                value={numberOfImages}
                onChange={(v) => this._handleChangeSpec('numberOfImages', v)}
                withCounter />
            </Cell>
            <Offset size="1of4" />
          </Grid>
        </div>
      </BaseServiceModal>
    );
  }

  @autobind
  _syncState() {
    const { estate, service } = this.props;
    const { specs } = this.state;
    const changes = specsToItems({ specs, estate, service });
    const updatedEstate = applyChanges(changes, estate);
    const items = getItemsByService(updatedEstate).exteriorRestyling;
    const price = items != null
      ? items
          .map((item) => item.estate != null ? item : { ...item, estate: updatedEstate })
          .reduce((memo, i) => memo + priceItem(i, this.props.sessionUser.currency.code, true), 0)
      : 0;
    this.setState({ price });
    return { changes, updatedEstate, price };
  }

  @autobind
  _handleChangeSpec(specKey, specValue) {
    const { specs } = this.state;
    const newValue = specValue ? specValue : (specs[specKey] !== 0 ? 0 : 1);
    this.setState({ specs: {
      ...this.state.specs,
      [specKey]: newValue,
      standard: newValue !== 0,
    }}, this._syncState);
  }

  @autobind
  _handleClickConfirm() {
    const { onModifyService, service } = this.props;
    const { changes } = this._syncState();
    onModifyService(changes, service);
  }
}


export default ExteriorRestyling;
